import React, { Component } from 'react';

import PropertyOption from './PropertyOption';
import PropertyValue from './PropertyValue';
import ConfirmDeleteIcon from '../../Buttons/ConfirmDeleteIcon';

import FetchData from '../../../Framework/Fetch';

type Props = {
  fields: any,
  handlePropertyRemove: any,
  index: number,
  item: string,
  properties: any,
  propertyGroupIndex: number,
  propertyGroupRecords: any,
  propertyIndex: number,
  record: any,
  selectedPropertyGroupValue: string
};

type StateProps = {
  choiceValues: string[],
  description: string
};

class Property extends Component<Props, StateProps> {
  state = { choiceValues: [], description: '' };

  componentDidMount() {
    if (
      this.props.propertyGroupRecords &&
      this.props.propertyGroupRecords[this.props.propertyGroupIndex] &&
      this.props.propertyGroupRecords[this.props.propertyGroupIndex].properties
    ) {
      const properties = this.props.propertyGroupRecords[this.props.propertyGroupIndex].properties

      if (properties[this.props.propertyIndex]) {
        const selectedProperty = properties[this.props.propertyIndex]

        if (this.props.selectedPropertyGroupValue) {
          FetchData('/helpers/lookup_property_options', {
            _end: 25, _order: 'DESC', _sort: 'updated_at', _start: 0, property_group_value: this.props.selectedPropertyGroupValue, property_value: selectedProperty.name
          })
            .then(json => {
              this.setState({ choiceValues: json });
            });
        }
      }
    }
  }

  handlePropertyChange = (e, index, value) => {
    const selectedProperty = this.props.properties.find(property => property.id === index);
    this.setState({ description: selectedProperty.description });

    FetchData('/helpers/lookup_property_options', {
      _end: 25, _order: 'DESC', _sort: 'updated_at', _start: 0, property_group_value: this.props.selectedPropertyGroupValue, property_value: selectedProperty.id
    })
      .then(json => {
        this.setState({ choiceValues: json });
      });
  }

  handleRemove = (event, index) => {
    this.props.handlePropertyRemove(event, index)
  }

  render() {
    return (
      <div>
        <div key={this.props.index} style={{ display: 'flex', width: '70%' }}>
          <PropertyOption
            handlePropertyChange={this.handlePropertyChange}
            item={this.props.item}
            propertyGroupIndex={this.props.propertyGroupIndex}
            properties={this.props.properties}
            propertyIndex={this.props.propertyIndex}
            record={this.props.record} />

          <PropertyValue
            choices={this.state.choiceValues}
            item={this.props.item}
            propertyGroupIndex={this.props.propertyGroupIndex}
            propertyIndex={this.props.propertyIndex}
            record={this.props.record} />

          <div style={{ flex: '1', paddingTop: 28 }}>
            <div style={{ display: 'inline' }}>
              <ConfirmDeleteIcon onClick={(event) => this.handleRemove(event, this.props.propertyIndex)} />
            </div>
          </div>
        </div>
        <div style={{ fontSize: 14, fontStyle: 'italic', color: 'rgba(0, 0, 0, 0.298039)' }}>
          {this.state.description}
        </div>
      </div>
    )
  }
};

export default Property;



// WEBPACK FOOTER //
// ./src/views/Common/Partials/PropertyGroups/Property.tsx